import {MarkerType, Position} from 'reactflow';
const convertPosition = (pos) => {
  switch (pos) {
    case 'L':
      return Position.Left;
    case 'R':
      return Position.Right;
    case 'T':
      return Position.Top;
    case 'B':
      return Position.Bottom;
    default:
      return null;
  }
};
// TODO: change Edge style hexcode color ref
const edgeStyle = {
  stroke: '#A1A4AC',
  strokeWidth: '2px',
  margin: 0,
  padding: 0,
}; //A1A4AC
const hiddenEdge = {stroke: 'none'};
// const labelStyle = {fontWeight: 1000};
// // TODO: no bg color hex ref
// const labelBgStyle = {fill: '#E1242A'};

export const transformData = (processMaps, selectedProcessMapNodes, process, subProcess) => {
  const {nodes, edges} = transformDataNodes(selectedProcessMapNodes, process, subProcess);
  const {mapNodes, mapEdges} = transformGroupData(processMaps, process, subProcess);
  const allNodes = nodes.concat(mapNodes);
  const allEdges = edges.concat(mapEdges);

  return {allNodes, allEdges};
};

/*
    transformData shapes the data given from the api into node and edge objects that ReactFlow consumes
    Input:
    operatingModel: the currently selected operating model as it is returned from the API
    process: (string) the currently selected process, used to filter nodes
    subProcess: (int) the index of the currently selected subProcess used to filter nodes 
        ex: (subprocess of ICF= Master ICF: 1, Country ICF: 2, Site ICF: 3,..) 

    Output:
    [nodes, edges] : a list of nodes and a list of edges in the format that our ReactFlow Process diagram expects
*/
const transformDataNodes = (selectedProcessMapNodes, process, subProcess) => {
  // console.log('transformData, process map nodes for: ' + process.name + ' and subProcess number ' + subProcess);
  const processMapNodes = selectedProcessMapNodes;

  // Filter for nodes of the given process and subProcess
  const filteredProcessNodes = processMapNodes.filter((process_map_node) => {
    const node = process_map_node;

    if (node.parent_label) {
      return node.process_name === process.process_id && node.parent_label.l1_label_order == subProcess;
    }
    return false;
  });
  ////// if this record represents a 'reference' or 'group' node, skip (determined by link to process_map.diagram_anchor)
  const nodes = [];
  const edges = [];

  filteredProcessNodes.forEach((process_map_node) => {
    const node = process_map_node;

    let position = {x: 0, y: 0};
    if (node.position_x != null && node.position_y != null) {
      position = {x: node.position_x, y: node.position_y};
    }

    // Add the task/step/decision node

    const newNode = {
      id: node.node_id,
      type: node.node_type ? node.node_type.toLowerCase() : '',
      data: {
        id: node.node_id,
        roles: node.raci,
        steps: node.steps,
        description: node.label,
        update: node.update, // TODO: confirm update field has been added
        diagram_link: node.diagram_link,
        diagram_link_id: node.diagram_link_id,
        position_x: node.position_x,
        position_y: node.position_y,
        position_in: node.position_in,
        position_in_target: node.position_in_target,
        position_in_alt_target: node.position_in_alt_target,
        position_out: node.position_out,
        process: node.process_name,
        header: node.header,
      },
      position: position,
      targetPosition: convertPosition(node.position_in),
      sourcePosition: convertPosition(node.position_out),
      parentNode: node.diagram_anchor,
      extent: 'parent',
      draggable: false,
    };
    nodes.push(newNode);
    // Add the edges that originate from this node
    node.parent_edge.forEach((edge) => {
      const edgeID = edge.parent_node.node_id + '-' + edge.child_node.node_id;
      const newEdge = {
        id: edgeID,
        data: {
          label: edge.child_node_path,
          parent_node_type: edge.parent_node.node_type,
          child_node_type: edge.child_node.node_type,
        },
        source: edge.parent_node.node_id,
        target: edge.child_node.node_id,
        sourceHandle: edge.position_out_source
          ? edge?.position_out_source
          : convertPosition(node.position_out) + 'Source',
        targetHandle: edge.position_in_target
          ? edge?.position_in_target
          : convertPosition(node.position_in_target) + 'Target',
        style: edgeStyle,
        type: 'custom',
        markerEnd: node.node_type !== 'guide' && {
          type: MarkerType.Arrow,
        },
      };
      // If the node is a decision, add labels and custom styles for yes/no edges
      if (edge.child_node_path == 'n') {
        newEdge.sourceHandle = convertPosition(node.position_out_alt) + 'Source';
        newEdge.targetHandle = convertPosition(node.position_in_alt_target) + 'Target';
      } else if (edge.child_node_path == 'y') {
        //helo
      }
      edges.push(newEdge);
    });
  });
  return {nodes, edges};
};

/*
    transformGroupData shapes data from the process_map table into group nodes that ReactFlow expects.
    This method has a similiar purpose as transformDataNodes with two exceptions
    - this method loops through process_map table, instead of process_map_node
    - this method returns only the 'L1' 'group' nodes used for the L1 map render and the group nodes used in the process diagram
*/
export const transformGroupData = (processMaps, process, subProcess) => {
  const filteredProcessMap = processMaps?.filter((process_map_record) => {
    const node = process_map_record;
    return node.process_name === process.process_id && node.l1_label_order == subProcess;
  });
  const mapNodes = [];
  const mapEdges = [];
  let previousGroupNode = null;
  filteredProcessMap?.forEach((process_map_record) => {
    const node = process_map_record;
    if (node.diagram_anchor == null || node.l2_label == null) {
      return;
    }
    const newMapNode = {
      id: node.diagram_anchor,
      type: 'group',
      data: {
        label: node.l2_label,
        id: node.diagram_anchor,
        roles: node.raci,
        phases: node.phases_list.split(';'),
        update: node.update,
      },
      targetPosition: Position.Left,
      sourcePosition: Position.Right,
      draggable: false,
    };
    mapNodes.push(newMapNode);
    if (previousGroupNode != null && previousGroupNode.diagram_anchor != null) {
      const newGroupEdge = {
        id: previousGroupNode.diagram_anchor + '-' + node.diagram_anchor,
        source: previousGroupNode.diagram_anchor,
        target: node.diagram_anchor,
        style: hiddenEdge,
        type: 'step',
      };
      mapEdges.push(newGroupEdge);
    }
    previousGroupNode = node;
  });
  return {mapNodes, mapEdges};
};
